<template>
  <mf-loading-dialog :loading="loading">
    <base-page-layout title="Resultados da consulta">
      <mf-button label="Voltar" color="marca-0-l40" icon="arrow_back" icon-position="left" text @click="goBack" />
      <v-card class="margin-bottom mt-2">
        <v-card-text>
          <consumer-header :consumer="consumer" />
          <v-divider class="my-4"></v-divider>

          <voucher-ze-history-table class="mt-4" :history="history" />
        </v-card-text>
      </v-card>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import BasePageLayout from '@/components/BasePageLayout.vue'
import { QUERY_ZE_COMPENSA } from '../../graphql'
import ConsumerHeader from '../components/ConsumerHeader.vue'
import VoucherZeHistoryTable from '../components/VoucherZeHistoryTable.vue'

export default {
  components: {
    BasePageLayout,
    ConsumerHeader,
    VoucherZeHistoryTable,
  },
  props: {
    documentNo: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    consumer: {},
    history: [],
  }),
  mounted() {
    if (!this.$getAllowedModules()['ze_delivery']) {
      this.$router.push({ name: 'consultar-ofertas' })
    } else if (typeof this.documentNo !== 'string') {
      this.goBack()
    } else {
      this.getData()
    }
  },
  methods: {
    localeString,
    goBack() {
      this.$router.push({ name: 'consultar-voucher-ze' })
    },
    async getData() {
      this.loading = true
      try {
        const response = await this.$apollo.query({
          query: QUERY_ZE_COMPENSA,
          variables: {
            input: {
              documentNo: this.documentNo,
              page: 1,
              pageSize: 100,
            },
          },
          fetchPolicy: 'no-cache',
        })
        const { benefitsMovementHistory } = response.data.getIndustryBenefitsMovementHistory
        this.history = benefitsMovementHistory
        if (this.history[0]?.user) {
          this.consumer = this.history[0].user
        } else {
          this.consumer = {
            documentNo: this.documentNo,
          }
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.margin-bottom {
  margin-bottom: 74px;
}

.bold-22px {
  font-size: 22px;
  font-weight: 700;
}

.normal-14px {
  font-size: 14px;
  font-weight: 400;
}

.color-marca-0-l10 {
  color: $marca-0-l10;
}

.color-marca-0-l30 {
  color: $marca-0-l30;
}

.color-cinza-0 {
  color: $cinza-0;
}
</style>
